import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scroller", "dot"]

  connect() {
    this._onWheel = this._onWheel.bind(this)
    this._update = this._update.bind(this)
    this.scroller.addEventListener("wheel", this._onWheel, { passive: false })
    this.scroller.addEventListener("scroll", this._update, { passive: true })
    this._update()
  }

  disconnect() {
    this.scroller.removeEventListener("wheel", this._onWheel)
    this.scroller.removeEventListener("scroll", this._update)
  }

  get scroller() {
    return this.hasScrollerTarget ? this.scrollerTarget : this.element
  }

  prev() {
    this.scrollBy(-this.step)
  }

  next() {
    this.scrollBy(this.step)
  }

  go(event) {
    const index = Number(event.currentTarget.dataset.horizontalScrollIndexParam)
    const target = this.scroller.children[index]
    if (!target) return

    this.scroller.scrollTo({ left: target.offsetLeft, behavior: "smooth" })
  }

  _onWheel(event) {
    if (this.scroller.scrollWidth <= this.scroller.clientWidth) return
    event.preventDefault()
    this.scrollBy(event.deltaY || event.deltaX)
  }

  scrollBy(left) {
    this.scroller.scrollBy({ left, behavior: "smooth" })
  }

  get step() {
    return this.scroller.clientWidth * 0.9
  }

  _update() {
    if (!this.hasDotTarget) return

    const cards = Array.from(this.scroller.children)
    const current = cards.reduce((closest, card, index) => {
      const distance = Math.abs(card.offsetLeft - this.scroller.scrollLeft)
      return distance < closest.distance ? { index, distance } : closest
    }, { index: 0, distance: Infinity }).index

    this.dotTargets.forEach((dot, index) => {
      const active = index === current
      dot.classList.toggle("bg-brand-700", active)
      dot.classList.toggle("text-white", active)
      dot.classList.toggle("shadow-md", active)
      dot.classList.toggle("bg-white", !active)
      dot.classList.toggle("text-ink-700", !active)
    })
  }
}
